import get from 'lodash/get'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import type { OptionType } from '../../../common/select/Select'
import Select from '../../../common/select/Select'
import { i18n } from '../../index'
import type { Station } from '../../station/stationTypes'
import withActiveStation from '../../station/withActiveStation'
import IndexDisplay from '../IndexDisplay'
import MonthDisplay from '../MonthDisplay'
import { getEmployeeSelectorOptions } from '../utils'
import FeelingReportGraph from './FeelingReportGraph'
import { fetchEmployeesList, fetchMonthlyFeelingReport, fetchStationsList } from './feelingReportQueries'
import FeelingReportTable from './FeelingReportTable'
import { MonthlyFeelingMeterData } from './feelingReportTypes'
import css from './Feelings.css'
type Props = {
  activeStation: Station
}
type State = {
  month: moment.Moment
  selectedEmployee: string
  selectedStation: string
}

@withActiveStation
class Feelings extends React.Component<Props, State> {
  state = {
    selectedEmployee: '',
    selectedStation: this.props.activeStation.id,
    month: moment(),
  }
  onChangeStation = (option: OptionType) => {
    this.setState({
      selectedStation: option.value,
      selectedEmployee: '',
    })
  }
  onChangeEmployee = (option: OptionType) => {
    this.setState({
      selectedEmployee: option.value,
    })
  }
  onChangeMonth = (step: number) => {
    const { month } = this.state
    this.setState({
      month: moment(month).add(step, 'months'),
    })
  }

  render() {
    const { selectedEmployee, selectedStation, month } = this.state
    return (
      <div>
        <div className={css.selectorGroup}>
          <Query query={fetchStationsList}>
            {({ loading, data, error }) => {
              const stations = get(data, 'stations.edges', [])
              return (
                <div className={css.selector}>
                  <div className={css.selectorLabel}>{i18n.t('reporting.chooseStation')}</div>
                  <Select
                    options={stations.map((station) => ({
                      label: get(station, 'node.name', '').toUpperCase(),
                      value: get(station, 'node.id', ''),
                    }))}
                    onChange={this.onChangeStation}
                    value={selectedStation}
                  />
                </div>
              )
            }}
          </Query>
          <Query
            query={fetchEmployeesList}
            variables={{
              stationId: selectedStation,
            }}
          >
            {({ loading, data, error }) => {
              const employees = get(data, 'employees.edges', [])
              return (
                <div className={css.selector}>
                  <div className={css.selectorLabel}>{i18n.t('reporting.chooseEmployee')}</div>
                  <Select
                    options={getEmployeeSelectorOptions(employees, 'employeeId')}
                    onChange={this.onChangeEmployee}
                    value={selectedEmployee}
                  />
                </div>
              )
            }}
          </Query>
        </div>
        <div>
          <Query
            query={fetchMonthlyFeelingReport}
            variables={{
              stationId: selectedStation,
              employeeId: selectedEmployee,
              year: moment(month).year(),
              month: moment(month).month(),
            }}
          >
            {({ data, loading, error }) => {
              const monthlyReport = get(data, 'reportMonthlyFeelingMeter', {
                byDay: [],
                yearAverage: 0,
                monthAverage: 0,
              }) as unknown as MonthlyFeelingMeterData
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  <IndexDisplay
                    label={i18n.t('reporting.label.feelingMeter.yearAverage')}
                    value={monthlyReport.yearAverage}
                  />
                  <MonthDisplay selectedMonth={month} onMonthChange={this.onChangeMonth} />
                  <FeelingReportTable data={monthlyReport} stationId={selectedStation} employeeId={selectedEmployee} />
                  <FeelingReportGraph data={monthlyReport} month={month} />
                </Loader>
              )
            }}
          </Query>
        </div>
      </div>
    )
  }
}

export default Feelings
